<template>
  <div class="form-container">
    <div
      class="form-container__content"
      :class="{
        'form-container__content--row': row,
        'form-container__content--gap': gap,
      }"
    >
      <slot />
    </div>
    <div v-if="$slots.bottomRow" class="form-container__bottom-row">
      <slot name="bottomRow" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FormContainer',
    props: {
      row: Boolean,
      gap: Boolean,
    },
  };
</script>

<style lang="scss" scoped>
  .form-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      width: 100%;

      &--gap {
        gap: 2px;
      }

      &--row {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }

    &__bottom-row {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      gap: 2px;
      width: 100%;
    }
  }
</style>
